import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from 'src/app/@shared/shared.module';

import { FilterPage } from 'src/app/filter/filter.page';

const routes: Routes = [
  {
    component: FilterPage,
    path: '',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule],
})
export class FilterPageModule {}
